import { createHashRouter, RouterProvider } from 'react-router-dom';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { JOBS_QUERY_KEY } from '../api/jobs';
import App from '../App';
import MainView from '../components/MainView';
import Overview from '../components/Overview';
import SequenceView from '../components/SequenceView';
import StacksView from '../components/stacks/StacksView';
import SkyPage from '../components/sky/SkyPage';
import CalibrationPage from '../components/calibration/CalibrationPage';
import PlanPage from '../components/director/PlanPage';
import LegacyPlanningRedirect from '../components/director/LegacyPlanningRedirect';

// Create React Query client
const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({
    // Most actions that start, stop or move a job are mutations: the
    // header reads its job list again when one settles.
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchInterval: 30000,
    },
  },
});

// Create hash router
const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: 'plan', element: <PlanPage /> },
      // Old Planning links: sent on to their plan or to the Library.
      { path: 'director', element: <LegacyPlanningRedirect /> },
      {
        index: true,
        element: <Overview />
      },
      {
        path: "overview",
        element: <Overview />
      },
      {
        path: "grid",
        element: <MainView />
      },
      {
        path: "detail/:imageId",
        element: <MainView />
      },
      {
        path: "compare/:leftImageId/:rightImageId",
        element: <MainView />
      },
      {
        path: "sequence",
        element: <SequenceView />
      },
      {
        path: "stacks",
        element: <StacksView />
      },
      {
        path: "sky",
        element: <SkyPage />
      },
      {
        path: "calibration",
        element: <CalibrationPage />
      }
    ]
  }
]);

export function AppRouter() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
